import React from "react";
import { Tooltip } from "@mui/material";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import moment from "moment";
import { OrderListItem } from "orderManagement/models";

type LastReset = Pick<OrderListItem, "lastEventResetAt" | "lastEventResetBy" | "lastEventResetAutoApproved">;

export const lastResetTooltip = (row: LastReset) => {
  const verdict =
    row.lastEventResetAutoApproved === true ? " · Auto-approved" : row.lastEventResetAutoApproved === false ? " · Auto-approve failed" : "";
  return `Events reset ${moment(row.lastEventResetAt).format("MM/DD/YYYY HH:mm")}${row.lastEventResetBy ? ` by ${row.lastEventResetBy}` : ""}${verdict}`;
};

/**
 * Review queue "Reset" cell: an icon when the trip's events were reset. Green when the bulk run
 * auto-approved the trip, amber when auto-approve failed, grey when there was no verdict.
 */
const LastResetCell: React.FC<{ row: LastReset }> = ({ row }) => {
  if (!row.lastEventResetAt) return null;
  const color =
    row.lastEventResetAutoApproved === true ? "success.main" : row.lastEventResetAutoApproved === false ? "warning.main" : "grey.500";
  const title = lastResetTooltip(row);
  return (
    <Tooltip title={title}>
      <RestartAltIcon fontSize="small" sx={{ color }} aria-label={title} data-testid="last-reset-icon" />
    </Tooltip>
  );
};

export default LastResetCell;
